export default "__VITE_ASSET__ab87b8a1__"